const adminMainInitialState = {
    isNotification: false,
    textNotification: '',
    popup: {},
}

const adminMainReduser = (state = adminMainInitialState, action) => {
    switch (action.type) {
        case 'notification':
            return { ...state, isNotification: action.item.isNotification, textNotification: action.item.textNotification };
        case 'updatePopup':
            return  { ...state, popup: action.item.popup }
        default:
            return state
    }
}

export default adminMainReduser;